import { ReactNode } from "react";
import cn from "classnames";
import { StatusProps } from "entities/shared/shipmentCard.types";
import { Button, ButtonIcon } from "shared/ui/Button";
import cardStyles from "../../Card.module.scss";
import styles from "./ErrorCard.module.scss";

import { CardBase } from "../../Card";

type ErrorStatus = "not-defined" | "error" | "warn";
export type ErrorCardProps = {
  className?: string;
  reference?: string | null;
  text?: ReactNode;
  status?: ErrorStatus;
  containerStatus?: StatusProps["status"];
  followLoading?: boolean;
  deleteLoading?: boolean;
  onSelect?: () => void;
  onRetry?: () => void;
  onFollow?: () => void;
  onDelete?: () => void;
};

export const ErrorCard: RFC<ErrorCardProps> = ({
  status = "not-defined",
  reference,
  text,
  onRetry,
  onDelete,
  className,
  children,
}) => {
  return (
    <CardBase className={cn(styles.errorCard, styles.noHeight, className)} reference={reference}>
      <CardBase.Row className={styles.row}>
        <div className={cn(styles.errorStatus, styles[status])} />
        {reference && <div className={styles.containerId}>{reference}</div>}
      </CardBase.Row>

      <CardBase.Row className={cn(styles.row, styles.body)}>
        <div className={styles.errorText}>{text}</div>
      </CardBase.Row>

      <CardBase.Row className={cn(styles.row, styles.footer, styles.alignEnd)}>
        <div className={cn(cardStyles["select-width"], styles.buttonsContainer)}>
          {onRetry && (
            <Button onClick={onRetry} variant="primary" size="tiny">
              Try again
            </Button>
          )}
          {children}
        </div>
        <ButtonIcon
          disabled={false}
          onClick={onDelete}
          icon="trash"
          size="tiny"
          className={cn(cardStyles.button, cardStyles.delete, styles.deleteButton)}
        />
      </CardBase.Row>
    </CardBase>
  );
};

ErrorCard.displayName = ErrorCard.name;
